import { createI18n } from 'vue-i18n';
import en from './locales/en.js';
import zh from './locales/zh.js';

export const messages = {
  en,
  zh,
};

export const DEFAULT_LOCALE = 'en';
export const SUPPORTED_LOCALES = ['en', 'zh'];

export function detectBrowserLocale() {
  const lang = navigator?.language || navigator?.userLanguage || DEFAULT_LOCALE;
  return lang.toLowerCase().startsWith('zh') ? 'zh' : 'en';
}

export function getStoredLocale() {
  if (typeof window === 'undefined') return null;
  const stored = window.localStorage.getItem('jiker-locale');
  return SUPPORTED_LOCALES.includes(stored) ? stored : null;
}

export function resolveInitialLocale() {
  return getStoredLocale() || detectBrowserLocale() || DEFAULT_LOCALE;
}

const initialLocale = resolveInitialLocale();

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: DEFAULT_LOCALE,
  messages,
  globalInjection: true,
});

setDocumentLang(initialLocale);

export function setDocumentLang(locale) {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
}

export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return;
  i18n.global.locale.value = locale;
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('jiker-locale', locale);
  }
  setDocumentLang(locale);
}

export default i18n;
